"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpTipHeader = void 0;
var react_1 = __importDefault(require("react"));
var global_styles_1 = require("../../Global/global.styles");
var storm_ui_1 = require("@amzn/storm-ui");
var HelpTipHeader = function (props) {
    var columnLabel = props.columnLabel, helpTipLabel = props.helpTipLabel, rows = props.rows;
    return (react_1.default.createElement(global_styles_1.FlexContainer, null,
        react_1.default.createElement(storm_ui_1.Text, { type: 'h5', textColor: rows.length === 0 ? 'tertiary' : 'base' }, columnLabel),
        react_1.default.createElement(storm_ui_1.HelpTip, null, helpTipLabel)));
};
exports.HelpTipHeader = HelpTipHeader;
